<!--
 * @Author: st 2946594574@qq.com
 * @Date: 2024-03-04 10:55:05
 * @LastEditors: yangiiiiii 14122140+yangiiiiiii@user.noreply.gitee.com
 * @LastEditTime: 2024-05-16 15:13:43
 * @FilePath: \com-project\src\views\login\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="login-container">
    <!-- 动态背景 -->
    <div class="background-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
    </div>

    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="top"
      v-loading="loading"
      element-loading-text="正在登录..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)"
    >
      <div class="title-container">
        <img class="logo-icon" :src="logoUrl" alt="logo">
        <h3 class="title">悉迹AI</h3>
        <p class="subtitle">学生、教师、家长均可使用账号登录</p>
      </div>

      <!-- 用户类型选择 -->
      <div class="user-type-selector">
        <span class="type-label">用户类型：</span>
        <el-radio-group v-model="loginForm.userType" size="small">
          <el-radio-button label="teacher">教师用户</el-radio-button>
          <el-radio-button label="student">学生用户</el-radio-button>
          <el-radio-button label="parent">家长用户</el-radio-button>
        </el-radio-group>
      </div>

      <el-form-item prop="username" label="用户名 / 邮箱 / 手机号" class="input-item">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          ref="username"
          v-model="loginForm.username"
          placeholder="请输入用户名/邮箱/手机号"
          name="username"
          type="text"
          tabindex="1"
          auto-complete="on"
        />
      </el-form-item>

      <el-form-item prop="password" label="密码" class="input-item">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          :key="passwordType"
          ref="password"
          v-model="loginForm.password"
          :type="passwordType"
          placeholder="请输入密码"
          name="password"
          tabindex="2"
          auto-complete="on"
          @keyup.enter.native="handleLogin"
        />
        <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-form-item>

      <div class="code-row">
        <el-form-item prop="code" label="验证码" class="code-item input-item">
          <span class="svg-container">
            <svg-icon icon-class="code" />
          </span>
          <el-input
            ref="codeInput"
            v-model="loginForm.code"
            placeholder="请输入验证码"
            name="code"
            type="text"
            tabindex="3"
            auto-complete="off"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <img
          ref="captchaImg"
          :src="captchaSrc"
          class="captcha-image"
          alt="点击刷新"
          @click="getVerify"
          @load="onCaptchaLoaded"
          @error="onCaptchaError"
        >
      </div>
      <el-button
        :loading="loading"
        type="primary"
        style="width: 100%; margin-bottom: 16px; margin-top: 8px;"
        @click.native.prevent="handleLogin"
      >登录</el-button>

      <div class="forgot-password-container">
        <router-link class="forgot-link" to="/forgot-password">忘记密码？</router-link>
      </div>

      <div class="contact-container">
        <router-link class="contact-link" to="/contact">联系我们</router-link>
      </div>

      <div v-if="enableRegister" class="register-link-container">
        <span class="register-text">还没有账号？</span>
        <router-link class="register-link" to="/register">立即注册</router-link>
      </div>

    </el-form>

    <el-dialog
      title="反馈"
      :visible.sync="feedbackVisible"
      width="520px"
      append-to-body
    >
      <el-form
        ref="feedbackForm"
        :model="feedbackForm"
        :rules="feedbackRules"
        label-position="top"
      >
        <el-form-item label="联系方式（选填）" prop="contact">
          <el-input v-model="feedbackForm.contact" placeholder="邮箱 / 电话 / 微信号等" />
        </el-form-item>
        <el-form-item label="反馈内容" prop="content">
          <el-input
            v-model="feedbackForm.content"
            type="textarea"
            :rows="5"
            placeholder="请描述你遇到的问题或建议"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="feedbackVisible = false">取消</el-button>
        <el-button type="primary" :loading="feedbackSending" @click="submitFeedback">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { validUsername } from '@/utils/validate'
import { getTokenInfo } from '@/utils/jwtUtils'
import { getCaptcha2, verifyCode2 } from '@/api/user'
import { sendFeedback } from '@/api/feedback'
import { Message } from 'element-ui'
import { Encrypt } from '@/utils/Secret'
import { getUserRedirectPath } from '@/utils/userStatus'
import { setToken } from '@/utils/auth'
export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('请输入用户名或邮箱'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: '',
        code: '',
        userType: 'student'
      },
      captchaId: '',
      captchaSrc: '',
      captchaLoaded: false,
      feedbackVisible: false,
      feedbackSending: false,
      feedbackForm: {
        contact: '',
        content: ''
      },
      feedbackRules: {
        content: [{ required: true, trigger: 'blur', message: '请输入反馈内容' }]
      },
      enableRegister: process.env.VUE_APP_ENABLE_REGISTER === 'true',
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        code: [{ required: true, trigger: 'blur', message: '请输入验证码' }]
      },
      loading: false,
      passwordType: 'password'
      // redirect: undefined,
    }
  },
  computed: {
    redirect() {
      return this.$route.query.redirect || '/'
    },
    logoUrl() {
      return `${process.env.BASE_URL}logo.png`
    }
  },
  // watch: {
  //   $route: {
  //     handler: function (route) {
  //       this.redirect = route.query && route.query.redirect;
  //     },
  //     immediate: true,
  //   },
  // },
  created() {
    // this.getEmail()
    this.getVerify()
  },
  mounted() {
    // 页面加载完成后自动聚焦到用户名输入框
    this.$nextTick(() => {
      this.$refs.username.focus()
    })
  },
  methods: {
    notifyOpenerAndClose(redirect) {
      try {
        if (window && window.opener && !window.opener.closed) {
          window.opener.postMessage({ type: 'LOGIN_SUCCESS', redirect: redirect || '/' }, '*')
          window.close()
          return true
        }
      } catch (e) {
        // ignore
      }
      return false
    },
    onCaptchaLoaded() {
      this.captchaLoaded = true
    },

    onCaptchaError() {
      this.captchaLoaded = false
    },
    openFeedbackDialog() {
      this.feedbackVisible = true
      this.$nextTick(() => {
        if (this.$refs.feedbackForm) {
          this.$refs.feedbackForm.clearValidate()
        }
      })
    },

    submitFeedback() {
      if (!this.$refs.feedbackForm) return
      this.$refs.feedbackForm.validate(async (valid) => {
        if (!valid) return
        this.feedbackSending = true
        try {
          const payload = {
            contact: this.feedbackForm.contact,
            content: this.feedbackForm.content,
            page: 'login'
          }
          const res = await sendFeedback(payload)
          if (res && res.code === 1) {
            Message.success(res.msg || '反馈已发送，感谢您的反馈！')
            this.feedbackVisible = false
            this.feedbackForm.contact = ''
            this.feedbackForm.content = ''
          } else {
            Message.error((res && res.msg) || '反馈发送失败')
          }
        } catch (e) {
          Message.error((e && e.message) || '反馈发送失败')
        } finally {
          this.feedbackSending = false
        }
      })
    },

    getVerify() {
      this.captchaLoaded = false
      this.captchaId = ''
      this.captchaSrc = ''
      getCaptcha2().then((res) => {
        const payload = res?.data ?? res
        const vo = payload?.data ?? payload
        this.captchaId = (vo && vo.captchaId) || ''
        this.captchaSrc = (vo && vo.imgBase64) || ''
        this.captchaLoaded = !!this.captchaSrc
      }).catch((e) => {
        console.error('获取验证码失败:', e)
        this.captchaLoaded = false
      })
    },

    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      if (!this.captchaLoaded || !this.captchaId) {
        this.$message.info('验证码加载中，请稍候…')
        this.getVerify()
        return
      }
      verifyCode2({ captchaId: this.captchaId, code: this.loginForm.code }).then((res) => {
        if (res.code) {
          this.$refs.loginForm.validate(async (valid) => {
            if (valid) {
              this.loading = true
              const loginData = {
                username: this.loginForm.username,
                password: Encrypt(this.loginForm.password)
              }
              console.log(loginData.password)
              // 统一使用通用登录接口（不再区分AMC用户和普通用户）
              this.$store
                .dispatch('user/login', loginData)
                  .then(() => {
                    this.$store.commit('menu/CLOSE_SIDEBAR')
                    const tokenUserInfo = getTokenInfo()
                    console.log('userInfo.id:', tokenUserInfo.id)
                    this.$store.dispatch('loginUser', { id: tokenUserInfo.id })
                    // 登录成功提示
                    Message.success('登录成功')
                    // 如果有 redirect 参数则跳转到指定页面，否则根据用户状态决定跳转页面
                    const redirectQuery = this.$route.query.redirect
                    if (redirectQuery && redirectQuery !== '/') {
                      if (this.notifyOpenerAndClose(redirectQuery)) {
                        this.loading = false
                        return
                      }
                      this.$router.push(redirectQuery)
                    } else {
                      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                      console.log('localStorage userInfo:', userInfo)
                      const redirectPath = getUserRedirectPath(userInfo)
                      console.log('redirectPath:', redirectPath)
                      if (this.notifyOpenerAndClose(redirectPath)) {
                        this.loading = false
                        return
                      }
                      this.$router.push(redirectPath)
                    }
                    this.loading = false
                  })
                  .catch((error) => {
                    this.getVerify()
                    const errMsg = (error && error.response && error.response.data && error.response.data.msg) ||
                      (error && error.msg) ||
                      (error && error.message) ||
                      '登录失败，请稍后重试'
                    Message.error(errMsg)
                    this.loading = false
                  })
            } else {
              return false
            }
          })
        } else {
          this.loginForm.code = '' // 清空验证码输入框
          this.getVerify()
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$bg: #0f172a;
$bg_light: #1e293b;
$light_gray: #f1f5f9;
$dark_gray: #94a3b8;
$primary: #3b82f6;
$primary_hover: #2563eb;
$surface: rgba(255, 255, 255, 0.08);
$border: rgba(255, 255, 255, 0.1);
$surface_hover: rgba(255, 255, 255, 0.12);
$accent: #8b5cf6;
$success: #10b981;

.login-container {
  min-height: 100%;
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  // 动态背景装饰
  .background-decoration {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 0;

    .circle {
      position: absolute;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      animation: float 20s infinite ease-in-out;
    }

    .circle-1 {
      width: 500px;
      height: 500px;
      top: -250px;
      left: -250px;
      animation-delay: 0s;
    }

    .circle-2 {
      width: 400px;
      height: 400px;
      bottom: -200px;
      right: -200px;
      animation-delay: 7s;
    }

    .circle-3 {
      width: 300px;
      height: 300px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      animation-delay: 14s;
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translate(0, 0) scale(1);
    }
    33% {
      transform: translate(50px, -50px) scale(1.1);
    }
    66% {
      transform: translate(-30px, 30px) scale(0.9);
    }
  }

  // 表单布局
  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
  ::v-deep .el-form--label-top .el-form-item__label {
    color: #334155;
    font-weight: 600;
    font-size: 14px;
    padding: 0 0 8px 2px;
    line-height: 1.2;
  }

  // 输入框样式
  .input-item {
    ::v-deep .el-input__inner {
      background: #ffffff;
      border: 2px solid #e2e8f0;
      color: #334155;
      border-radius: 12px;
      padding: 12px 15px;
      padding-left: 45px;
      font-size: 15px;
      font-weight: 500;
      transition: all 0.3s ease;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      &:hover {
        border-color: #94a3b8;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
      }

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
        outline: none;
        background: #ffffff;
      }
    }
  }

  // placeholder 样式
  .input-item {
    ::v-deep .el-input__inner::placeholder { color: #94a3b8; }
    ::v-deep .el-input__inner::-webkit-input-placeholder { color: #94a3b8; }
    ::v-deep .el-input__inner::-moz-placeholder { color: #94a3b8; }
    ::v-deep .el-input__inner:-ms-input-placeholder { color: #94a3b8; }
    ::v-deep .el-input__inner::-ms-input-placeholder { color: #94a3b8; }
  }

  .login-form {
    position: relative;
    width: 560px;
    max-width: 90%;
    padding: 48px 50px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 24px;
    box-shadow:
      0 8px 32px rgba(0, 0, 0, 0.1),
      0 0 0 1px rgba(255, 255, 255, 0.2) inset;
    overflow: visible;
    z-index: 1;
    animation: slideUp 0.6s ease-out;
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .el-form-item {
    position: relative;
  }

  .svg-container {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #64748b;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    pointer-events: none;
  }

  .title-container {
    position: relative;
    text-align: center;
    margin-bottom: 32px;

    .logo-icon {
      width: 140px;
      height: auto;
      max-width: 180px;
      max-height: 180px;
      object-fit: contain;
      display: inline-block;
      border-radius: 16px;
      margin-bottom: 16px;
      animation: bounce 2s infinite;
    }

    @keyframes bounce {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-10px);
      }
    }

    .title {
      font-size: 32px;
      color: #1e293b;
      margin: 0 auto 8px;
      font-weight: 700;
      letter-spacing: -0.5px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .subtitle {
      font-size: 14px;
      color: #64748b;
      margin: 0;
      font-weight: 400;
    }
  }

  .show-pwd {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    color: #64748b;
    cursor: pointer;
    user-select: none;
    z-index: 2;
    transition: all 0.3s ease;

    &:hover {
      color: #667eea;
    }
  }

  // 用户类型选择样式
  .user-type-selector {
    margin-bottom: 24px;
    padding: 16px;
    background: #f8fafc;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;

    .type-label {
      flex: 0 0 72px;
      color: #334155;
      font-size: 14px;
      font-weight: 600;
      line-height: 36px;
    }

    ::v-deep .el-radio-group {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 8px;
      background: #ffffff;
      padding: 4px;
      border-radius: 10px;
      border: 2px solid #e2e8f0;
    }

    ::v-deep .el-radio-button {
      width: 100%;
      min-width: 0;
    }

    ::v-deep .el-radio-button__orig-radio {
      display: none;
    }

    ::v-deep .el-radio-button__inner {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      color: #64748b;
      border: none;
      padding: 8px 12px;
      border-radius: 8px;
      font-weight: 600;
      transition: all 0.3s ease;
    }

    ::v-deep .el-radio-button__inner:hover {
      color: #3b82f6;
    }

    ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }

    ::v-deep .el-radio-button__inner:hover {
      background: #f1f5f9;
      color: #3b82f6;
    }

    @media (max-width: 768px) {
      .type-label {
        flex: 0 0 72px;
      }
    }
  }

  // 验证码输入行样式
  .code-row {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 18px;

    .code-item {
      flex: 1;
      margin-bottom: 0;
    }

    .captcha-image {
      margin-top: 30px;
      height: 46px;
      min-width: 120px;
      border-radius: 12px;
      border: 2px solid #e2e8f0;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      &:hover {
        transform: translateY(-2px);
        border-color: #667eea;
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
      }
    }
  }

  // 主按钮美化
  ::v-deep .el-button--primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    padding: 14px 0;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;

    &:hover, &:focus {
      transform: translateY(-2px);
      box-shadow: 0 12px 32px rgba(102, 126, 234, 0.4);
      background: linear-gradient(135deg, #5568d3 0%, #6a3e8f 100%);
    }

    &:active {
      transform: translateY(0);
    }

    &.is-disabled, &.is-loading {
      opacity: 0.6;
      transform: none;
      box-shadow: none;
    }
  }

  // 错误提示样式
  ::v-deep .el-form-item__error {
    color: #ef4444;
    padding-left: 15px;
    font-size: 12px;
    margin-top: 6px;
    font-weight: 500;
    line-height: 1.4;
  }

  // 忘记密码链接样式
  .forgot-password-container {
    text-align: center;
    margin-bottom: 12px;
    position: relative;
    z-index: 10;

    .forgot-link {
      color: #667eea;
      font-size: 13px;
      font-weight: 500;
      text-decoration: none;
      transition: all 0.3s ease;
      cursor: pointer;
      display: inline-block;
      padding: 4px 8px;

      &:hover {
        color: #5568d3;
      }
    }
  }

  .contact-container {
    text-align: center;
    margin-bottom: 12px;
    position: relative;
    z-index: 10;

    .contact-link {
      color: #667eea;
      font-size: 13px;
      font-weight: 500;
      text-decoration: none;
      transition: all 0.3s ease;
      cursor: pointer;
      display: inline-block;
      padding: 4px 8px;

      &:hover {
        color: #5568d3;
      }
    }
  }

  // 注册链接样式
  .register-link-container {
    text-align: center;
    padding: 16px 0 8px;

    .register-text {
      color: #64748b;
      font-size: 14px;
      margin-right: 8px;
    }

    .register-link {
      color: #667eea;
      font-size: 14px;
      font-weight: 600;
      text-decoration: none;
      position: relative;
      transition: all 0.3s ease;

      &:after {
        content: '';
        position: absolute;
        width: 0;
        height: 2px;
        bottom: -2px;
        left: 0;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        transition: width 0.3s ease;
      }

      &:hover {
        color: #5568d3;

        &:after {
          width: 100%;
        }
      }
    }
  }
}
</style>
